import { CastType } from '@/types/casts'
import { computed, ComputedRef } from '@vue/composition-api'
import { Cast } from '../classes'

const useIsCastType = (cast: ComputedRef<Cast|null>) => {
  const isPlainCast = computed(() => cast.value?.castType === CastType.Plain)
  const isSwitcherCast = computed(() => cast.value?.castType === CastType.Switcher)
  const isFanRoomCast = computed(() => cast.value?.castType === CastType.FanRoom)
  const isStationSwicherCast = computed(() => cast.value?.castType === CastType.StationSwitcher)

  return {
    isPlainCast,
    isSwitcherCast,
    isFanRoomCast,
    isStationSwicherCast
  }
}

export default useIsCastType
